import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../styles/Sidebar.css";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>

      <button className="hamburger-menu" onClick={() => setIsOpen(!isOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <h2>Admin Panel</h2>
        <ul>
          <li>
            <NavLink to="/admin/batches" className={({ isActive }) => isActive ? "active" : ""}>
              View All Batches
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/products" className={({ isActive }) => isActive ? "active" : ""}>
              View All Products
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/add-batch" className={({ isActive }) => isActive ? "active" : ""}>
              Add New Batch
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/add-product" className={({ isActive }) => isActive ? "active" : ""}>
              Add New Product
            </NavLink>
          </li>
 
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
